webpackJsonp([62],{

/***/ 1355:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(78);

/***/ }),

/***/ 1360:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(77);

/***/ }),

/***/ 1517:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_users_users_api_js__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);





/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    /**
     * 判断是否为图片文件
     * @param {string} url - 文件URL
     * @returns {boolean}
     */
    isImageFile: function isImageFile(url) {
      if (!url) return false;

      // 最后通过文件扩展名判断
      try {
        var path = new URL(url).pathname;
        var ext = path.split('.').pop().toLowerCase();
        if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp', 'tiff', 'tif'].includes(ext)) {
          console.log(url + ' match img ext');
          return true;
        }
      } catch (error) {
        // do nothing
        console.log(error);
      }
      return false;
    },

    /**
     * 判断是否为视频文件
     * @param {string} url - 文件URL
     * @returns {boolean}
     */
    isVideoFile: function isVideoFile(url) {
      if (!url) return false;

      // 通过 URL 中的存储桶关键字快速判断
      var videoBuckets = ['sjrawvideopub.', 'sjrawvideopubdev.', 'sjvideopub.', 'sjvideopubdev.', 'sjvideopubcnv.', 'sjvideopubcnvdev.'];
      if (videoBuckets.some(function (bucket) {
        return url.includes(bucket);
      })) {
        console.log(url + ' match video bucket name');
        return true;
      }
      // 最后通过文件扩展名判断
      try {
        var path = new URL(url).pathname;
        var ext = path.split('.').pop().toLowerCase();
        if (['mp4', 'webm', 'ogg', 'mov', 'avi', 'wmv', 'flv', 'mkv', 'mpeg', 'mpg', 'm3u8', 'mpd'].includes(ext)) {
          console.log(url + ' match video ext');
          return true;
        }
      } catch (error) {
        // do nothing
      }
      return false;
    },
    onChangeUserWorkInfoEvidence: function onChangeUserWorkInfoEvidence(file) {
      var fileType = file.raw.type;
      var fileSizeMB = file.raw.size / 1024 / 1024;
      var isImage = fileType === 'image/jpeg' || fileType === 'image/png';
      var isVideo = fileType === 'video/mp4';
      if (!isImage && !isVideo) {
        this.$message.error('请上传jpg/png图片或mp4视频!');
        return false;
      }
      if (isImage && fileSizeMB > 5) {
        this.$message.error('图片大小不能超过5MB!');
        return false;
      }
      if (isVideo && fileSizeMB > 200) {
        this.$message.error('视频大小不能超过200MB!');
        return false;
      }
      return this.doAdminDirectUploadFile(file.raw);
    },
    doAdminDirectUploadFile: function doAdminDirectUploadFile(file) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, res, uploadUrl, contentType, uploadRes;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                params = {
                  file_name: file.name,
                  ext: file.name.split('.').pop().toLowerCase(),
                  content_type: file.type || 'application/octet-stream'
                };
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_2__views_users_users_api_js__["adminDirectUploadFilesApi"])(params);

              case 4:
                res = _context.sent;

                if (!(res.data.ret === 0)) {
                  _context.next = 17;
                  break;
                }

                uploadUrl = res.data.detail.signedUrl;
                contentType = res.data.detail.content_type;
                _context.next = 10;
                return fetch(uploadUrl, {
                  method: 'PUT',
                  headers: new Headers({ 'Content-Type': contentType }),
                  body: file
                });

              case 10:
                uploadRes = _context.sent;

                if (uploadRes.ok) {
                  _context.next = 13;
                  break;
                }

                throw new Error('\u4E0A\u4F20\u5931\u8D25\uFF0C\u539F\u56E0: ' + uploadRes.status);

              case 13:
                _this.$message({ message: '上传成功', type: 'success' });
                return _context.abrupt('return', res.data.detail.url);

              case 17:
                _this.$message.error('上传失败，原因: ' + res.data.msg);
                return _context.abrupt('return', false);

              case 19:
                _context.next = 25;
                break;

              case 21:
                _context.prev = 21;
                _context.t0 = _context['catch'](0);

                _this.$message.error('上传失败，原因: ' + _context.t0.message);
                return _context.abrupt('return', false);

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 21]]);
      }))();
    },

    // 附件上传,标准化字段结构
    formatStandardFile: function formatStandardFile(file, loginUser) {
      return {
        submit_admin_id: loginUser.id,
        submit_admin_name: loginUser.name,
        submit_at: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD HH:mm:ss'),
        name: file.name,
        size: file.size,
        url: file.url,
        uid: file.uid
      };
    }
  }
});

/***/ }),

/***/ 1523:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VideoPlayerDialog',
  props: {
    // 是否显示弹窗（支持 .sync）
    visible: {
      type: Boolean,
      default: false
    },
    // 视频 URL 列表
    videos: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 打开时默认播放的视频索引
    index: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      currentIndex: 0,
      currentUrl: '',
      scale: 1,
      rotation: 0,
      translateX: 0,
      translateY: 0,
      isDragging: false,
      instantReset: false,
      dragStartX: 0,
      dragStartY: 0,
      startTranslateX: 0,
      startTranslateY: 0,
      isPlaying: false,
      videoCurrentTime: 0,
      videoDuration: 0
    };
  },

  computed: {
    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  watch: {
    visible: function visible(val) {
      var _this = this;

      if (val) {
        this.currentIndex = Math.min(Math.max(this.index, 0), Math.max(this.videos.length - 1, 0));
        this.currentUrl = this.videos[this.currentIndex] || '';
        this.resetVideoState();
        this.$nextTick(function () {
          var wrapper = _this.$refs.videoDialogWrapper;
          wrapper && wrapper.focus();
        });
      }
    }
  },
  methods: {
    /**
     * 关闭弹窗时的清理
     */
    handleClose: function handleClose() {
      this.currentUrl = '';
      this.resetVideoState();
    },

    /**
     * ESC 关闭弹窗
     */
    closeDialog: function closeDialog() {
      this.dialogVisible = false;
    },

    /**
     * 重置视频播放状态
     */
    resetVideoState: function resetVideoState() {
      this.scale = 1;
      this.rotation = 0;
      this.translateX = 0;
      this.translateY = 0;
      this.isDragging = false;
      this.isPlaying = false;
      this.videoCurrentTime = 0;
      this.videoDuration = 0;
    },

    /**
     * @param {string} url 视频地址
     */
    goToVideo: function goToVideo(url) {
      var _this2 = this;

      this.instantReset = true;
      this.currentUrl = url;
      this.resetVideoState();
      this.$nextTick(function () {
        _this2.instantReset = false;
      });
    },

    /**
     * 切换到上一个视频
     */
    prevVideo: function prevVideo() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.goToVideo(this.videos[this.currentIndex] || '');
      }
    },

    /**
     * 切换到下一个视频
     */
    nextVideo: function nextVideo() {
      if (this.currentIndex < this.videos.length - 1) {
        this.currentIndex++;
        this.goToVideo(this.videos[this.currentIndex] || '');
      }
    },

    /**
     * 点击缩略图直接播放指定视频
     * @param {number} i 视频索引
     */
    playVideoByIndex: function playVideoByIndex(i) {
      if (i === this.currentIndex) return;
      if (i < 0 || i >= this.videos.length) return;
      this.currentIndex = i;
      this.goToVideo(this.videos[i] || '');
    },

    /**
     * 视频滚轮缩放
     * @param {WheelEvent} e
     */
    onVideoWheel: function onVideoWheel(e) {
      var delta = e.deltaY > 0 ? -0.1 : 0.1;
      var newScale = this.scale + delta;
      newScale = Math.max(0.5, Math.min(5, newScale));
      this.scale = parseFloat(newScale.toFixed(2));
    },
    rotateVideo: function rotateVideo() {
      this.rotation += 90;
    },

    /**
     * 开始拖拽视频
     * @param {MouseEvent} e
     */
    onDragStart: function onDragStart(e) {
      if (e.button !== 0) return;
      this.isDragging = true;
      this.dragStartX = e.clientX;
      this.dragStartY = e.clientY;
      this.startTranslateX = this.translateX;
      this.startTranslateY = this.translateY;
    },

    /**
     * 拖拽中
     * @param {MouseEvent} e
     */
    onDragMove: function onDragMove(e) {
      if (!this.isDragging) return;
      this.translateX = this.startTranslateX + (e.clientX - this.dragStartX) / this.scale;
      this.translateY = this.startTranslateY + (e.clientY - this.dragStartY) / this.scale;
    },

    /**
     * 结束拖拽
     */
    onDragEnd: function onDragEnd() {
      this.isDragging = false;
    },

    /**
     * 切换播放/暂停
     */
    togglePlay: function togglePlay() {
      var video = this.$refs.videoPlayer;
      if (!video) return;
      if (video.paused) {
        video.play();
        this.isPlaying = true;
      } else {
        video.pause();
        this.isPlaying = false;
      }
    },

    /**
     * 视频播放进度更新
     */
    onTimeUpdate: function onTimeUpdate() {
      var video = this.$refs.videoPlayer;
      if (video) {
        this.videoCurrentTime = video.currentTime;
      }
    },

    /**
     * 视频元数据加载完成
     */
    onLoadedMeta: function onLoadedMeta() {
      var video = this.$refs.videoPlayer;
      if (video) {
        this.videoDuration = video.duration || 0;
      }
    },

    /**
     * 视频播放结束
     */
    onVideoEnded: function onVideoEnded() {
      this.isPlaying = false;
    },

    /**
     * 点击进度条跳转
     * @param {MouseEvent} e
     */
    seekVideo: function seekVideo(e) {
      var video = this.$refs.videoPlayer;
      var track = e.currentTarget;
      if (!video || !track || !this.videoDuration) return;
      var rect = track.getBoundingClientRect();
      var ratio = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
      video.currentTime = ratio * this.videoDuration;
      this.videoCurrentTime = video.currentTime;
    },

    /**
     * 格式化视频时间
     * @param {number} seconds
     * @returns {string}
     */
    formatVideoTime: function formatVideoTime(seconds) {
      if (!isFinite(seconds) || seconds < 0) return '00:00';
      var m = Math.floor(seconds / 60);
      var s = Math.floor(seconds % 60);
      return String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
    }
  }
});

/***/ }),

/***/ 1575:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoPlayerDialog_vue__ = __webpack_require__(1523);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a2c49d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoPlayerDialog_vue__ = __webpack_require__(1599);
function injectStyle (ssrContext) {
  __webpack_require__(1597)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoPlayerDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a2c49d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoPlayerDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1597:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1598);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("073a162c", content, true, {});

/***/ }),

/***/ 1598:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".video-player-dialog.el-dialog{background-color:rgba(0,0,0,.5);-webkit-box-shadow:none!important;box-shadow:none!important;margin:0!important;width:100%!important;height:100vh;border-radius:0}.video-player-dialog .el-dialog__body{padding:0;height:100%;background-color:transparent!important}.video-player-dialog .el-dialog__header{padding:0}.video-player-dialog .el-dialog__headerbtn{position:fixed;top:-40px;right:-40px;width:80px;height:80px;margin:0;background-color:rgba(0,0,0,.5);border-radius:50%;overflow:hidden;-webkit-transition:background-color .15s;transition:background-color .15s;z-index:2050}.video-player-dialog .el-dialog__headerbtn:focus,.video-player-dialog .el-dialog__headerbtn:hover{background-color:rgba(0,0,0,.8)}.video-player-dialog .el-dialog__headerbtn .el-dialog__close{position:absolute;bottom:15px;left:15px;color:#fff;font-size:22px}.video-player-dialog .video-dialog-wrapper{-ms-flex-align:center;-ms-flex-pack:center;height:100%;position:relative;padding:0 60px;outline:none;overflow:hidden}.video-player-dialog .video-dialog-content,.video-player-dialog .video-dialog-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center}.video-player-dialog .video-dialog-content{-webkit-box-flex:1;-ms-flex:1;flex:1;-ms-flex-align:center;-ms-flex-pack:center;cursor:-webkit-grab;cursor:grab;padding-bottom:130px;-webkit-box-sizing:border-box;box-sizing:border-box;background-color:transparent!important}.video-player-dialog .video-dialog-content.is-dragging{cursor:-webkit-grabbing;cursor:grabbing}.video-player-dialog .video-transform-wrapper{display:inline-block;position:relative;-webkit-transition:-webkit-transform .1s ease-out;transition:-webkit-transform .1s ease-out;transition:transform .1s ease-out;transition:transform .1s ease-out,-webkit-transform .1s ease-out;-webkit-transform-origin:center center;transform-origin:center center;background-color:transparent!important}.video-player-dialog .video-transform-wrapper.no-transition{-webkit-transition:none;transition:none}.video-player-dialog .video-player{margin-top:10px;max-width:100%;max-height:calc(100vh - 130px);width:auto;height:auto;outline:none;background-color:transparent;display:block;cursor:pointer}.video-player-dialog .video-nav-arrow{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:44px;height:44px;border-radius:50%;background-color:hsla(0,0%,100%,.6);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;cursor:pointer;-webkit-transition:background-color .3s,opacity .3s;transition:background-color .3s,opacity .3s;z-index:10}.video-player-dialog .video-nav-arrow i{font-size:22px;color:#fff;-webkit-text-stroke:2px #fff}.video-player-dialog .video-nav-arrow:hover{background-color:hsla(0,0%,100%,.4)}.video-player-dialog .video-nav-arrow.disabled{opacity:.3;cursor:not-allowed}.video-player-dialog .video-nav-arrow.disabled:hover{background-color:hsla(0,0%,100%,.2)}.video-player-dialog .video-nav-prev{left:12px}.video-player-dialog .video-nav-next{right:12px}.video-player-dialog .custom-video-controls{position:absolute;bottom:75px;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);height:40px;width:50%;background:rgba(0,0,0,.5);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;padding:0 16px;z-index:20;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.video-player-dialog .custom-video-controls .control-btn{font-size:36px;color:#fff;cursor:pointer;-ms-flex-negative:0;flex-shrink:0;-webkit-transition:opacity .2s;transition:opacity .2s;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:32px;height:32px;margin-left:-10px}.video-player-dialog .custom-video-controls .progress-track{-webkit-box-flex:1;-ms-flex:1;flex:1;height:6px;background:hsla(0,0%,100%,.25);border-radius:3px;cursor:pointer;position:relative;overflow:hidden}.video-player-dialog .custom-video-controls .progress-track:hover{height:8px;border-radius:4px}.video-player-dialog .custom-video-controls .progress-fill{height:100%;background:#409eff;border-radius:inherit;pointer-events:none}.video-player-dialog .custom-video-controls .time-text{font-size:12px;color:#fff;white-space:nowrap;-ms-flex-negative:0;flex-shrink:0;font-variant-numeric:tabular-nums}.video-player-dialog .custom-video-controls .scale-text{font-size:12px;color:#c0c4cc;white-space:nowrap;-ms-flex-negative:0;flex-shrink:0;font-variant-numeric:tabular-nums;min-width:32px;text-align:right}.video-player-dialog .video-thumbnails{position:absolute;bottom:0;left:0;right:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;gap:8px;padding:8px 16px;background:rgba(0,0,0,.5);overflow-x:auto;z-index:20;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.video-player-dialog .video-thumbnails::-webkit-scrollbar{height:6px}.video-player-dialog .video-thumbnails::-webkit-scrollbar-thumb{background:hsla(0,0%,100%,.3);border-radius:3px}.video-player-dialog .video-thumbnails .video-thumb-item{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:36px;height:54px;border-radius:4px;overflow:hidden;cursor:pointer;border:2px solid transparent;opacity:.7;-webkit-transition:border-color .2s,opacity .2s,-webkit-transform .2s;transition:border-color .2s,opacity .2s,-webkit-transform .2s;transition:border-color .2s,opacity .2s,transform .2s;transition:border-color .2s,opacity .2s,transform .2s,-webkit-transform .2s}.video-player-dialog .video-thumbnails .video-thumb-item:hover{opacity:1;-webkit-transform:translateY(-2px);transform:translateY(-2px)}.video-player-dialog .video-thumbnails .video-thumb-item.active{border-color:#409eff;opacity:1}.video-player-dialog .video-thumbnails .video-thumb-item .video-thumb-player{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;display:block;background-color:#000}", "", {"version":3,"sources":["/workspace/src/views/user-workinfo/components/VideoPlayerDialog.vue"],"names":[],"mappings":"AACA,+BAA+B,gCAAiC,kCAAmC,0BAA2B,mBAAoB,qBAAsB,aAAa,eAAe,CACnM,AACD,sCAAsC,UAAU,YAAY,sCAAuC,CAClG,AACD,wCAAwC,SAAS,CAChD,AACD,2CAA2C,eAAe,UAAU,YAAY,WAAW,YAAY,SAAS,gCAAiC,kBAAkB,gBAAgB,yCAA0C,iCAAkC,YAAY,CAC1Q,AACD,kGAAkG,+BAAgC,CACjI,AACD,6DAA6D,kBAAkB,YAAY,UAAU,WAAW,cAAc,CAC7H,AACD,2CAAyH,sBAAsB,AAA2C,qBAAqB,AAAuB,YAAY,kBAAkB,eAAe,aAAa,eAAe,CAC9S,AACD,sFAF2C,oBAAoB,oBAAoB,aAAa,yBAAyB,AAAsB,mBAAmB,wBAAwB,AAAqB,sBAAuB,CAGrO,AADD,2CAA2C,mBAAmB,WAAW,OAAO,AAA8E,sBAAsB,AAA2C,qBAAqB,AAAuB,oBAAoB,YAAY,qBAAqB,8BAA8B,sBAAsB,sCAAuC,CAC1Z,AACD,uDAAuD,wBAAwB,eAAe,CAC7F,AACD,8CAA8C,qBAAqB,kBAAkB,kDAAmD,0CAA2C,kCAAmC,iEAAoE,uCAAuC,+BAA+B,sCAAuC,CACtY,AACD,4DAA4D,wBAAwB,eAAe,CAClG,AACD,mCAAmC,gBAAgB,eAAe,+BAA+B,WAAW,YAAY,aAAa,6BAA6B,cAAc,cAAc,CAC7L,AACD,sCAAsC,kBAAkB,QAAQ,mCAAmC,2BAA2B,WAAW,YAAY,kBAAkB,oCAAuC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,eAAe,oDAAuD,4CAA+C,UAAU,CACvgB,AACD,wCAAwC,eAAe,WAAW,4BAA4B,CAC7F,AACD,4CAA4C,mCAAsC,CACjF,AACD,+CAA+C,WAAY,kBAAkB,CAC5E,AACD,qDAAqD,mCAAsC,CAC1F,AACD,qCAAqC,SAAS,CAC7C,AACD,qCAAqC,UAAU,CAC9C,AACD,4CAA4C,kBAAkB,YAAY,SAAS,mCAAmC,2BAA2B,YAAY,UAAU,0BAA2B,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,SAAS,eAAe,WAAW,yBAAyB,sBAAsB,qBAAqB,gBAAgB,CAC/a,AACD,yDAAyD,eAAe,WAAW,eAAe,oBAAoB,cAAc,+BAAgC,uBAAwB,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,WAAW,YAAY,iBAAiB,CACnb,AACD,4DAA4D,mBAAmB,WAAW,OAAO,WAAW,+BAAkC,kBAAkB,eAAe,kBAAkB,eAAe,CAC/M,AACD,kEAAkE,WAAW,iBAAiB,CAC7F,AACD,2DAA2D,YAAY,mBAAmB,sBAAsB,mBAAmB,CAClI,AACD,uDAAuD,eAAe,WAAW,mBAAmB,oBAAoB,cAAc,iCAAiC,CACtK,AACD,wDAAwD,eAAe,cAAc,mBAAmB,oBAAoB,cAAc,kCAAkC,eAAe,gBAAgB,CAC1M,AACD,uCAAuC,kBAAkB,SAAS,OAAO,QAAQ,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,uBAAuB,QAAQ,iBAAiB,0BAA2B,gBAAgB,WAAW,yBAAyB,sBAAsB,qBAAqB,gBAAgB,CAC5W,AACD,0DAA0D,UAAU,CACnE,AACD,gEAAgE,8BAAiC,iBAAiB,CACjH,AACD,yDAAyD,mBAAmB,kBAAkB,cAAc,WAAW,YAAY,kBAAkB,gBAAgB,eAAe,6BAA6B,WAAY,sEAA2E,8DAAmE,sDAA2D,2EAAkF,CACvf,AACD,+DAA+D,UAAU,mCAAmC,0BAA0B,CACrI,AACD,gEAAgE,qBAAqB,SAAS,CAC7F,AACD,6EAA6E,WAAW,YAAY,oBAAoB,iBAAiB,cAAc,qBAAqB,CAC3K","file":"VideoPlayerDialog.vue","sourcesContent":["\n.video-player-dialog.el-dialog{background-color:rgba(0,0,0,0.5);-webkit-box-shadow:none !important;box-shadow:none !important;margin:0 !important;width:100% !important;height:100vh;border-radius:0\n}\n.video-player-dialog .el-dialog__body{padding:0;height:100%;background-color:transparent !important\n}\n.video-player-dialog .el-dialog__header{padding:0\n}\n.video-player-dialog .el-dialog__headerbtn{position:fixed;top:-40px;right:-40px;width:80px;height:80px;margin:0;background-color:rgba(0,0,0,0.5);border-radius:50%;overflow:hidden;-webkit-transition:background-color 0.15s;transition:background-color 0.15s;z-index:2050\n}\n.video-player-dialog .el-dialog__headerbtn:focus,.video-player-dialog .el-dialog__headerbtn:hover{background-color:rgba(0,0,0,0.8)\n}\n.video-player-dialog .el-dialog__headerbtn .el-dialog__close{position:absolute;bottom:15px;left:15px;color:#fff;font-size:22px\n}\n.video-player-dialog .video-dialog-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:100%;position:relative;padding:0 60px;outline:none;overflow:hidden\n}\n.video-player-dialog .video-dialog-content{-webkit-box-flex:1;-ms-flex:1;flex:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;cursor:-webkit-grab;cursor:grab;padding-bottom:130px;-webkit-box-sizing:border-box;box-sizing:border-box;background-color:transparent !important\n}\n.video-player-dialog .video-dialog-content.is-dragging{cursor:-webkit-grabbing;cursor:grabbing\n}\n.video-player-dialog .video-transform-wrapper{display:inline-block;position:relative;-webkit-transition:-webkit-transform 0.1s ease-out;transition:-webkit-transform 0.1s ease-out;transition:transform 0.1s ease-out;transition:transform 0.1s ease-out, -webkit-transform 0.1s ease-out;-webkit-transform-origin:center center;transform-origin:center center;background-color:transparent !important\n}\n.video-player-dialog .video-transform-wrapper.no-transition{-webkit-transition:none;transition:none\n}\n.video-player-dialog .video-player{margin-top:10px;max-width:100%;max-height:calc(100vh - 130px);width:auto;height:auto;outline:none;background-color:transparent;display:block;cursor:pointer\n}\n.video-player-dialog .video-nav-arrow{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:44px;height:44px;border-radius:50%;background-color:rgba(255,255,255,0.6);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;cursor:pointer;-webkit-transition:background-color 0.3s, opacity 0.3s;transition:background-color 0.3s, opacity 0.3s;z-index:10\n}\n.video-player-dialog .video-nav-arrow i{font-size:22px;color:#fff;-webkit-text-stroke:2px #fff\n}\n.video-player-dialog .video-nav-arrow:hover{background-color:rgba(255,255,255,0.4)\n}\n.video-player-dialog .video-nav-arrow.disabled{opacity:0.3;cursor:not-allowed\n}\n.video-player-dialog .video-nav-arrow.disabled:hover{background-color:rgba(255,255,255,0.2)\n}\n.video-player-dialog .video-nav-prev{left:12px\n}\n.video-player-dialog .video-nav-next{right:12px\n}\n.video-player-dialog .custom-video-controls{position:absolute;bottom:75px;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);height:40px;width:50%;background:rgba(0,0,0,0.5);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;padding:0 16px;z-index:20;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none\n}\n.video-player-dialog .custom-video-controls .control-btn{font-size:36px;color:#fff;cursor:pointer;-ms-flex-negative:0;flex-shrink:0;-webkit-transition:opacity 0.2s;transition:opacity 0.2s;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:32px;height:32px;margin-left:-10px\n}\n.video-player-dialog .custom-video-controls .progress-track{-webkit-box-flex:1;-ms-flex:1;flex:1;height:6px;background:rgba(255,255,255,0.25);border-radius:3px;cursor:pointer;position:relative;overflow:hidden\n}\n.video-player-dialog .custom-video-controls .progress-track:hover{height:8px;border-radius:4px\n}\n.video-player-dialog .custom-video-controls .progress-fill{height:100%;background:#409eff;border-radius:inherit;pointer-events:none\n}\n.video-player-dialog .custom-video-controls .time-text{font-size:12px;color:#fff;white-space:nowrap;-ms-flex-negative:0;flex-shrink:0;font-variant-numeric:tabular-nums\n}\n.video-player-dialog .custom-video-controls .scale-text{font-size:12px;color:#c0c4cc;white-space:nowrap;-ms-flex-negative:0;flex-shrink:0;font-variant-numeric:tabular-nums;min-width:32px;text-align:right\n}\n.video-player-dialog .video-thumbnails{position:absolute;bottom:0;left:0;right:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;gap:8px;padding:8px 16px;background:rgba(0,0,0,0.5);overflow-x:auto;z-index:20;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none\n}\n.video-player-dialog .video-thumbnails::-webkit-scrollbar{height:6px\n}\n.video-player-dialog .video-thumbnails::-webkit-scrollbar-thumb{background:rgba(255,255,255,0.3);border-radius:3px\n}\n.video-player-dialog .video-thumbnails .video-thumb-item{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:36px;height:54px;border-radius:4px;overflow:hidden;cursor:pointer;border:2px solid transparent;opacity:0.7;-webkit-transition:border-color 0.2s, opacity 0.2s, -webkit-transform 0.2s;transition:border-color 0.2s, opacity 0.2s, -webkit-transform 0.2s;transition:border-color 0.2s, opacity 0.2s, transform 0.2s;transition:border-color 0.2s, opacity 0.2s, transform 0.2s, -webkit-transform 0.2s\n}\n.video-player-dialog .video-thumbnails .video-thumb-item:hover{opacity:1;-webkit-transform:translateY(-2px);transform:translateY(-2px)\n}\n.video-player-dialog .video-thumbnails .video-thumb-item.active{border-color:#409eff;opacity:1\n}\n.video-player-dialog .video-thumbnails .video-thumb-item .video-thumb-player{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;display:block;background-color:#000\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1599:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":_vm.dialogVisible,"width":"100%","top":"0px","modal":false,"append-to-body":"","custom-class":"video-player-dialog"},on:{"update:visible":function($event){_vm.dialogVisible=$event},"close":_vm.handleClose}},[_c('div',{ref:"videoDialogWrapper",staticClass:"video-dialog-wrapper",attrs:{"tabindex":"-1"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.togglePlay($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"r",undefined,$event.key,undefined)){ return null; }$event.preventDefault();return _vm.rotateVideo($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.closeDialog($event)}],"wheel":function($event){$event.preventDefault();return _vm.onVideoWheel($event)}}},[(_vm.videos.length > 1)?_c('div',{staticClass:"video-nav-arrow video-nav-prev",class:{ disabled: _vm.currentIndex === 0 },on:{"click":_vm.prevVideo}},[_c('i',{staticClass:"el-icon-arrow-left"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"video-dialog-content",class:{ 'is-dragging': _vm.isDragging },on:{"mousedown":_vm.onDragStart,"mousemove":_vm.onDragMove,"mouseup":_vm.onDragEnd,"mouseleave":_vm.onDragEnd}},[_c('div',{staticClass:"video-transform-wrapper",class:{ 'no-transition': _vm.isDragging || _vm.instantReset },style:({ transform: ("scale(" + _vm.scale + ") translate(" + _vm.translateX + "px, " + _vm.translateY + "px) rotate(" + _vm.rotation + "deg)") })},[(_vm.currentUrl)?_c('video',{ref:"videoPlayer",staticClass:"video-player",attrs:{"src":_vm.currentUrl,"autoplay":""},on:{"timeupdate":_vm.onTimeUpdate,"loadedmetadata":_vm.onLoadedMeta,"play":function($event){_vm.isPlaying = true},"pause":function($event){_vm.isPlaying = false},"ended":_vm.onVideoEnded}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"custom-video-controls"},[_c('div',{staticClass:"control-btn",attrs:{"title":"播放/暂停（按 空格 键切换）"},on:{"click":_vm.togglePlay}},[(!_vm.isPlaying)?_c('svg',{staticStyle:{"display":"block"},attrs:{"viewBox":"0 0 24 24","width":"32","height":"32","fill":"#fff","stroke":"#fff","stroke-width":"2","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M6 5 L19 12 L6 19 Z"}})]):_c('svg',{staticStyle:{"display":"block"},attrs:{"viewBox":"0 0 24 24","width":"32","height":"32","fill":"none","stroke":"#fff","stroke-width":"3","stroke-linecap":"round"}},[_c('line',{attrs:{"x1":"7","y1":"5","x2":"7","y2":"19"}}),_vm._v(" "),_c('line',{attrs:{"x1":"17","y1":"5","x2":"17","y2":"19"}})])]),_vm._v(" "),_c('div',{staticClass:"progress-track",on:{"click":_vm.seekVideo}},[_c('div',{staticClass:"progress-fill",style:({ width: _vm.videoDuration ? (_vm.videoCurrentTime / _vm.videoDuration * 100) + '%' : '0%' })})]),_vm._v(" "),_c('span',{staticClass:"time-text"},[_vm._v(_vm._s(_vm.formatVideoTime(_vm.videoCurrentTime))+" / "+_vm._s(_vm.formatVideoTime(_vm.videoDuration)))]),_vm._v(" "),_c('div',{staticClass:"control-btn",staticStyle:{"margin-left":"0"},attrs:{"title":"向右旋转（快捷键 R）"},on:{"click":_vm.rotateVideo}},[_c('svg',{staticStyle:{"display":"block"},attrs:{"viewBox":"0 0 24 24","width":"32","height":"32","fill":"none","stroke":"#fff","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('rect',{attrs:{"x":"9","y":"11","width":"11","height":"11","rx":"1.2"}}),_vm._v(" "),_c('path',{attrs:{"d":"M5 14 C5 10, 8 6, 14 6"}}),_vm._v(" "),_c('path',{attrs:{"d":"M14 6 L11 4 M14 6 L11 8"}})])]),_vm._v(" "),_c('span',{staticClass:"scale-text",attrs:{"title":"通过滚轮控制缩放大小"}},[_vm._v(_vm._s((_vm.scale * 100).toFixed(0))+"%")])]),_vm._v(" "),(_vm.videos.length)?_c('div',{staticClass:"video-thumbnails"},_vm._l((_vm.videos),function(url,i){return _c('div',{key:i,staticClass:"video-thumb-item",class:{ active: i === _vm.currentIndex },on:{"click":function($event){return _vm.playVideoByIndex(i)}}},[_c('video',{staticClass:"video-thumb-player",attrs:{"src":url,"preload":"metadata","muted":"","playsinline":""},domProps:{"muted":true}})])}),0):_vm._e(),_vm._v(" "),(_vm.videos.length > 1)?_c('div',{staticClass:"video-nav-arrow video-nav-next",class:{ disabled: _vm.currentIndex === _vm.videos.length - 1 },on:{"click":_vm.nextVideo}},[_c('i',{staticClass:"el-icon-arrow-right"})]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3080:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_viewerjs_dist_viewer_css__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_viewerjs_dist_viewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_viewerjs_dist_viewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_viewerjs__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_viewerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_viewerjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_user_workinfo_components_work_info_history_WorkInfoHistory_vue__ = __webpack_require__(5771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_user_workinfo_components_VideoPlayerDialog_vue__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_user_workinfo_user_workinfo_mixin_js__ = __webpack_require__(1517);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { WorkInfoHistory: __WEBPACK_IMPORTED_MODULE_6__views_user_workinfo_components_work_info_history_WorkInfoHistory_vue__["a" /* default */], VideoPlayerDialog: __WEBPACK_IMPORTED_MODULE_7__views_user_workinfo_components_VideoPlayerDialog_vue__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_8__views_user_workinfo_user_workinfo_mixin_js__["a" /* default */]],
  data: function data() {
    return {
      detail: {},
      activeName: '职业信息提交详情',
      auditForm: {
        failed_reason: null
      },
      editForm: {
        business_type: null,
        work_type: null,
        belongto: null,
        main_brand: null,
        workcard_photo: [],
        tag_add: []
      },
      companyList: [],
      existingTags: [],
      industryTags: [],
      videoDialogVisible: false,
      videoDialogVideos: [],
      videoDialogIndex: 0,
      // 相对首次快照，零工新补的工作证明 URL（后端对比 SJUserWorkInfoAuditSnapshot）
      newWorkcardPhotos: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.users.userOptions;
    }
  }), {
    filtered_work_type: function filtered_work_type() {
      var _this = this;

      return this.options.business_work_type.filter(function (it) {
        return it.businessTypeId + '' === _this.editForm.business_type + '';
      });
    },
    reversedLogs: function reversedLogs() {
      var logs = Array.isArray(this.detail.log) ? this.detail.log : [];
      return [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(logs)).reverse();
    },
    newWorkcardPhotoSet: function newWorkcardPhotoSet() {
      var list = Array.isArray(this.newWorkcardPhotos) ? this.newWorkcardPhotos : [];
      var set = {};
      list.forEach(function (url) {
        if (url) set[url] = true;
      });
      return set;
    }
  }),
  created: function created() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.$store.dispatch('getUserRelatedOptions');

            case 2:
              _this2.id = _this2.$route.params.id;
              _this2.id > 0 && _this2.setDetailData(_this2.id);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), request.map(['getUserTagTable', 'getUserTagDetail', 'queryWorkInfoCompany']), {
    // 加载用户当前已有的标签，仅用于审核页展示
    loadExistingTags: function loadExistingTags() {
      var _this3 = this;

      var tagStr = this.detail.tag || '';
      var ids = tagStr ? tagStr.split(',').map(function (id) {
        return Number(id);
      }).filter(function (id) {
        return !isNaN(id) && id > 0;
      }) : [];
      this.existingTags = [];
      if (!ids.length) {
        return;
      }
      this.getUserTagTable({ tag_id: ids }).then(function (_ref) {
        var data = _ref.data;

        var list = data && data.data || [];
        var normalized = list.map(function (tag) {
          return {
            id: Number(tag.id),
            tagname: tag.tagname || tag.name || '标签' + tag.id
          };
        });
        _this3.existingTags = ids.map(function (id) {
          var found = normalized.find(function (t) {
            return t.id === id;
          });
          return found || { id: id, tagname: '标签' + id };
        });
      }).catch(function () {
        // 出错时，至少按照 ID 简单展示
        _this3.existingTags = ids.map(function (id) {
          return { id: id, tagname: '标签' + id };
        });
      });
    },
    needMainBrand: function needMainBrand() {
      var btId = this.editForm.business_type;
      if (!btId) return false;
      var item = (this.options.business_type || []).find(function (it) {
        return Number(it.id) === Number(btId);
      });
      return item && item.need_main_brand;
    },
    onBusinessTypeChange: function onBusinessTypeChange() {
      this.editForm.work_type = null;
      this.loadIndustryTags();
    },

    // 根据当前行业加载对应的标签名称
    loadIndustryTags: function loadIndustryTags() {
      var _this4 = this;

      var btId = this.editForm.business_type;
      this.industryTags = [];
      if (!btId) return;
      var item = (this.options.business_type || []).find(function (it) {
        return Number(it.id) === Number(btId);
      });
      var bindTags = item && item.bind_tags;
      if (typeof bindTags === 'string') {
        try {
          bindTags = JSON.parse(bindTags);
        } catch (e) {
          bindTags = [];
        }
      }
      var ids = Array.isArray(bindTags) ? bindTags.map(function (id) {
        return Number(id);
      }).filter(function (id) {
        return id > 0;
      }) : [];
      if (!ids.length) return;
      this.getUserTagTable({ tag_id: ids }).then(function (_ref2) {
        var data = _ref2.data;

        var list = data && data.data || [];
        var normalized = list.map(function (tag) {
          return {
            id: Number(tag.id),
            tagname: tag.tagname || tag.name || '标签' + tag.id
          };
        });
        _this4.industryTags = ids.map(function (id) {
          return normalized.find(function (t) {
            return t.id === id;
          }) || { id: id, tagname: '标签' + id };
        });
      }).catch(function () {
        _this4.industryTags = ids.map(function (id) {
          return { id: id, tagname: '标签' + id };
        });
      });
    },
    setDetailData: function setDetailData(id) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return request.page('getUserWorkInfoDetail', { id: id }).then(function (_ref3) {
                  var data = _ref3.data;

                  // 不再需要处理 tag，因为现在使用 tag_add
                  _this5.detail = data;
                  // 保存公司列表
                  _this5.companyList = data.company_list || [];
                  // 零工新补证据（相对首次快照）；管理端本页上传不会进此列表
                  _this5.newWorkcardPhotos = data.new_workcard_photos || [];
                  // 初始化编辑表单
                  _this5.editForm = {
                    business_type: data.business_type ? Number(data.business_type) : null,
                    work_type: data.work_type ? Number(data.work_type) : null,
                    belongto: data.belongto || null,
                    workcard_photo: data.workcard_photo || [],
                    main_brand: data.main_brand || null,
                    tag_add: []
                    // 加载当前用户已存在的标签，仅用于展示
                  };_this5.loadExistingTags();
                  // 加载行业对应标签
                  _this5.loadIndustryTags();
                });

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },

    /**
     * 是否为零工驳回后新补的工作证明（相对首次快照）
     * 管理端上传的证据不在 new_workcard_photos 中，故不会标红点
     */
    isNewWorkcardPhoto: function isNewWorkcardPhoto(photo) {
      return !!(photo && this.newWorkcardPhotoSet[photo]);
    },
    ifKey: function ifKey(scope, name) {
      return scope.row.key === name;
    },
    setStatusCNColor: function setStatusCNColor() {
      switch (Number(this.detail.status)) {
        case 0:
          return 'orange';
        case 1:
          return 'green';
        case 2:
          return 'red';
        default:
          return 'xx';
      }
    },
    auditPass: function auditPass() {
      var _this6 = this;

      var auditForm = {
        id: this.id,
        tag_add: this.editForm.tag_add || [],
        updated_at: this.detail.updated_at,
        is_rejected: 0,
        business_type: this.editForm.business_type,
        work_type: this.editForm.work_type,
        belongto: this.editForm.belongto,
        main_brand: this.editForm.main_brand,
        workcard_photo: this.editForm.workcard_photo
        // 当前行业需要主营品牌时，前端做必填校验
      };if (this.needMainBrand() && !this.editForm.main_brand) {
        this.$message.warning('当前行业需要填写主营品牌');
        return;
      }
      this.$confirm('确认审核通过？', '提示', { type: 'success' }).then(function () {
        request.common('auditUserWorkInfoData', auditForm).then(function () {
          _this6.auditNext('已通过，是否审核下一条用户职业信息？');
        });
      });
    },
    auditReject: function auditReject() {
      var _this7 = this;

      // 前端验证：不通过原因必填
      if (!this.auditForm.failed_reason || this.auditForm.failed_reason.trim() === '') {
        this.$message.warning('请填写不通过原因');
        return;
      }

      var auditForm = {
        id: this.id,
        tag_add: this.editForm.tag_add || [],
        is_rejected: 1,
        updated_at: this.detail.updated_at,
        failed_reason: this.auditForm.failed_reason,
        business_type: this.editForm.business_type,
        work_type: this.editForm.work_type,
        belongto: this.editForm.belongto,
        main_brand: this.editForm.main_brand,
        workcard_photo: this.editForm.workcard_photo
      };
      this.$confirm('确认审核不通过？', '提示', { type: 'success' }).then(function () {
        request.common('auditUserWorkInfoData', auditForm).then(function (res) {
          _this7.auditNext('审核不通过处理成功，是否审核下一条用户职业信息？');
        });
      }, function () {});
    },
    auditNext: function auditNext(msg) {
      var _this8 = this;

      this.$confirm(msg, '提示', {
        type: 'success', confirmButtonText: '审核下一条', cancelButtonText: '返回列表', showClose: false
      }).then(function () {
        request.common('getNextAuditWorkInfoId', {}).then(function (res) {
          if (res.data > 0) {
            self.location.href = '/user-workinfo/audit/' + res.data;
          } else {
            _this8.$alert('无更多待审核数据', '提示', { type: 'warning', confirmButtonText: '返回列表' }).then(function () {
              _this8.goBackToTable();
            });
          }
        });
      }, function () {
        _this8.goBackToTable();
      });
    },
    goBackToTable: function goBackToTable() {
      this.$router.push({ path: '/user-workinfo/table' });
    },
    allowAudit: function allowAudit() {
      return this.detail.status + '' === '0' && this.$route.meta.type === 'audit';
    },
    onViewPhotos: function onViewPhotos(index) {
      if (this.viewer) {
        this.viewer.destroy();
      }
      this.viewer = new __WEBPACK_IMPORTED_MODULE_5_viewerjs___default.a(document.getElementById('photoContainer'));
      this.viewer.view(index);
    },
    getBusinessType: function getBusinessType() {
      return _.get(this.detail, 'business_type_json.title', '-');
    },
    getMainBrand: function getMainBrand() {
      var value = _.get(this.detail, 'main_brand');
      if (value && value.toString().trim() !== '') {
        return value;
      }
      // 如果当前行业配置为需要主营品牌，即使为空也要展示占位符，方便运营发现未填写
      if (this.needMainBrand()) {
        return '—';
      }
      return null;
    },
    getUserLocation: function getUserLocation() {
      var province = _.get(this.detail, 'province_name', '');
      var city = _.get(this.detail, 'city_name', '');
      var area = _.get(this.detail, 'area_name', '');
      var location = '';
      if (province) location += ' ' + province;
      if (city) location += ' ' + city;
      if (area) location += ' ' + area;
      return location;
    },
    onChangeFile: function onChangeFile(file) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this9.onChangeUserWorkInfoEvidence(file);

              case 2:
                url = _context3.sent;

                if (url) {
                  _this9.editForm.workcard_photo.push(url);
                }

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this9);
      }))();
    },
    onDeletePhoto: function onDeletePhoto(index) {
      this.editForm.workcard_photo.splice(index, 1);
    },
    queryCompanyList: function queryCompanyList(queryString, cb) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var emptyList, _ref4, data, companies, formattedResults, _emptyList;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(!queryString || queryString.trim() === '')) {
                  _context4.next = 4;
                  break;
                }

                emptyList = [];

                cb(emptyList);
                return _context4.abrupt('return');

              case 4:
                _context4.prev = 4;
                _context4.next = 7;
                return request.common('queryWorkInfoCompany', {
                  name: queryString.trim(),
                  per_page: 20, // 限制返回数量
                  current_page: 1
                });

              case 7:
                _ref4 = _context4.sent;
                data = _ref4.data;
                companies = data && data.data || [];
                // 格式化数据为 el-autocomplete 需要的格式

                formattedResults = companies.map(function (company) {
                  return {
                    value: company.name,
                    id: company.id
                  };
                });

                cb(formattedResults);
                _context4.next = 19;
                break;

              case 14:
                _context4.prev = 14;
                _context4.t0 = _context4['catch'](4);

                console.error('搜索公司失败:', _context4.t0);
                // 出错时返回空数组
                _emptyList = [];

                cb(_emptyList);

              case 19:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this10, [[4, 14]]);
      }))();
    },
    handleCompanySelect: function handleCompanySelect(item) {
      this.editForm.belongto = item.value;
    },
    reloadData: function reloadData() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return _this11.$confirm('确认还原数据？还原后将重新加载当前数据。', '提示', { type: 'warning' });

              case 3:
                _context5.next = 5;
                return _this11.setDetailData(_this11.id);

              case 5:
                _this11.$message({
                  showClose: true,
                  message: '数据还原成功',
                  type: 'success'
                });
                _context5.next = 11;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5['catch'](0);

                // 用户取消操作时不显示错误消息
                if (_context5.t0 !== 'cancel') {
                  _this11.$message({
                    showClose: true,
                    message: '数据还原失败',
                    type: 'error'
                  });
                }

              case 11:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this11, [[0, 8]]);
      }))();
    },

    /**
     * 打开视频播放弹窗（委托给独立组件 VideoPlayerDialog）
     * @param {string} url - 视频URL
     * @param {number} index - 在 workcard_photo 中的索引（保留以兼容调用处）
     */
    openVideoDialog: function openVideoDialog(url, index) {
      var _this12 = this;

      // 构造所有视频URL列表，并计算当前索引
      var videoList = (this.editForm.workcard_photo || []).filter(function (photo) {
        return _this12.isVideoFile(photo);
      });
      this.videoDialogVideos = videoList;
      this.videoDialogIndex = Math.max(videoList.indexOf(url), 0);
      this.videoDialogVisible = true;
    }
  })
});

/***/ }),

/***/ 3081:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_viewerjs_dist_viewer_css__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_viewerjs_dist_viewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_viewerjs_dist_viewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_user_workinfo_user_workinfo_mixin_js__ = __webpack_require__(1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_viewerjs__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_viewerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_viewerjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_user_workinfo_components_VideoPlayerDialog_vue__ = __webpack_require__(1575);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__views_user_workinfo_user_workinfo_mixin_js__["a" /* default */]],
  name: 'WorkInfoHistory',
  components: { VideoPlayerDialog: __WEBPACK_IMPORTED_MODULE_6__views_user_workinfo_components_VideoPlayerDialog_vue__["a" /* default */] },
  props: {
    userId: {
      type: [String, Number],
      required: true
    }
  },
  data: function data() {
    return {
      dataList: [],
      loading: false,
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      columns: [{ prop: 'id', label: '快照ID' }, { prop: 'sj_user_workinfo_audit_id', label: '审核数据ID' }, { prop: 'created_at', label: '提交时间', width: 180 }, { prop: 'updated_by', label: '提交人' }, { prop: 'business_type_json', label: '行业' }, { prop: 'work_type_cn', label: '工种' }, { prop: 'content.belongto', label: '公司名称' }],
      videoDialogVisible: false,
      videoDialogVideos: [],
      videoDialogIndex: 0
    };
  },

  watch: {
    userId: {
      immediate: true,
      handler: function handler() {
        this.getData();
      }
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch('getUserRelatedOptions');

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    userOptions: function userOptions(state) {
      return state.users.userOptions;
    }
  })),
  methods: {
    getData: function getData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                _context2.prev = 1;
                _context2.next = 4;
                return request.common('queryWorkInfoSnapshotApi', {
                  userid: _this2.userId,
                  current_page: _this2.pagination.current,
                  per_page: _this2.pagination.size
                });

              case 4:
                _ref = _context2.sent;
                data = _ref.data;

                _this2.dataList = data.data;
                _this2.pagination.total = data.total;

              case 8:
                _context2.prev = 8;

                _this2.loading = false;
                return _context2.finish(8);

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1,, 8, 11]]);
      }))();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pagination.size = size;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(current) {
      this.pagination.current = current;
      this.getData();
    },
    onViewPhotos: function onViewPhotos(index, i) {
      if (this.viewer) {
        this.viewer.destroy();
      }
      this.viewer = new __WEBPACK_IMPORTED_MODULE_5_viewerjs___default.a(document.getElementById('photoContainer' + i));
      this.viewer.view(index);
    },
    getBusinessType: function getBusinessType(row) {
      var businessTypeId = _.get(row, 'content.business_type');
      var businessTypeObj = this.userOptions.business_type.find(function (it) {
        return it.id + '' === businessTypeId + '';
      });
      return _.get(businessTypeObj, 'title', '-');
    },

    /**
     * 打开视频播放弹窗（委托给独立组件 VideoPlayerDialog）
     * @param {string} url - 视频URL
     * @param {number} index - 在 workcard_photo 中的索引（保留以兼容调用处）
     * @param {object} row - 当前行数据
     */
    openVideoDialog: function openVideoDialog(url, index, row) {
      var _this3 = this;

      var videoList = (row.content.workcard_photo || []).filter(function (photo) {
        return _this3.isVideoFile(photo);
      });
      this.videoDialogVideos = videoList;
      this.videoDialogIndex = Math.max(videoList.indexOf(url), 0);
      this.videoDialogVisible = true;
    }
  }
});

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserWorkInfoDetail_vue__ = __webpack_require__(3080);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_210c3db8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserWorkInfoDetail_vue__ = __webpack_require__(5775);
function injectStyle (ssrContext) {
  __webpack_require__(5767)
  this["$style"] = __webpack_require__(5769)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-210c3db8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserWorkInfoDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_210c3db8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserWorkInfoDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 5767:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5768);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("63ad03f7", content, true, {});

/***/ }),

/***/ 5768:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".re-el-form__flex .large[data-v-210c3db8]{width:100%;max-width:none}.form-input-width[data-v-210c3db8]{width:400px;max-width:100%}.form-input-width .el-input[data-v-210c3db8],.form-input-width .el-input__inner[data-v-210c3db8],.form-input-width .el-select[data-v-210c3db8],.form-input-width .el-select__tags-text[data-v-210c3db8],.form-input-width .el-select__tags[data-v-210c3db8]{width:100%!important;max-width:100%}.form-input-width>[data-v-210c3db8]{width:100%!important}.el-form-item[data-v-210c3db8]{margin-bottom:22px}.el-form-item[data-v-210c3db8]:last-child{margin-bottom:0}.user-info-wrapper[data-v-210c3db8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;-ms-flex-wrap:wrap;flex-wrap:wrap}.user-info-wrapper .info-divider[data-v-210c3db8]{color:#dcdfe6;font-size:14px;-ms-flex-negative:0;flex-shrink:0}.user-info-wrapper .info-text[data-v-210c3db8]{color:#606266;font-size:14px;white-space:nowrap}.workcard-upload-wrapper[data-v-210c3db8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:16px}.photo-view-container[data-v-210c3db8]{gap:20px;margin-top:12px}.photo-item[data-v-210c3db8]{position:relative;display:inline-block}.photo-new-dot[data-v-210c3db8]{position:absolute;top:2px;left:2px;width:8px;height:8px;background-color:#f56c6c;border-radius:50%;border:1px solid #fff;-webkit-box-shadow:0 0 2px rgba(0,0,0,.25);box-shadow:0 0 2px rgba(0,0,0,.25);z-index:2;pointer-events:none}.workcard-image[data-v-210c3db8]{width:100px;height:100px;border:1px solid #dcdfe6;border-radius:4px;cursor:pointer;-webkit-transition:border-color .3s;transition:border-color .3s}.workcard-image[data-v-210c3db8]:hover{border-color:#409eff}.photo-delete-icon[data-v-210c3db8]{position:absolute;top:-8px;right:-8px;font-size:20px;cursor:pointer;color:#f56c6c;background:#fff;border-radius:50%;width:20px;height:20px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-shadow:0 2px 4px rgba(0,0,0,.12);box-shadow:0 2px 4px rgba(0,0,0,.12);-webkit-transition:-webkit-transform .2s;transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s}.photo-delete-icon[data-v-210c3db8]:hover{-webkit-transform:scale(1.1);transform:scale(1.1)}.photo-view-container[data-v-210c3db8]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:12px}.photo-view-image[data-v-210c3db8]{width:80px;height:80px;-o-object-fit:cover;object-fit:cover;border:1px solid #dcdfe6;border-radius:4px;cursor:-webkit-zoom-in;cursor:zoom-in;-webkit-transition:border-color .3s,-webkit-transform .2s;transition:border-color .3s,-webkit-transform .2s;transition:border-color .3s,transform .2s;transition:border-color .3s,transform .2s,-webkit-transform .2s}.photo-view-image[data-v-210c3db8]:hover{border-color:#409eff;-webkit-transform:scale(1.05);transform:scale(1.05)}.photo-view-image.unknown-file[data-v-210c3db8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background-color:#f5f7fa;cursor:default;font-size:12px;color:#909399;text-align:center;padding:4px;-webkit-box-sizing:border-box;box-sizing:border-box}.photo-view-image.unknown-file i[data-v-210c3db8]{font-size:24px;margin-bottom:2px;color:#dcdfe6}.photo-view-image.unknown-file span[data-v-210c3db8]{line-height:1.2;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%}.photo-item video.photo-view-image[data-v-210c3db8]{cursor:pointer;background-color:#1a1a1a;pointer-events:auto!important}.photo-item video.photo-view-image[data-v-210c3db8]::-webkit-media-controls{display:-webkit-box!important;display:flex!important;opacity:1!important}.log-container[data-v-210c3db8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:0;padding:0;background-color:#f5f7fa;border-radius:4px;max-height:300px;overflow-y:auto;border:1px solid #ebeef5;max-width:800px}.log-header[data-v-210c3db8]{display:grid;grid-template-columns:150px 150px 400px;gap:12px;padding:12px 16px;background-color:#fafafa;border-bottom:1px solid #ebeef5;font-weight:600;font-size:14px;color:#303133;position:-webkit-sticky;position:sticky;top:0;z-index:1}.log-header .log-action-header[data-v-210c3db8],.log-header .log-operator-header[data-v-210c3db8],.log-header .log-time-header[data-v-210c3db8]{color:#303133}.log-item[data-v-210c3db8]{display:grid;grid-template-columns:150px 150px 400px;gap:12px;padding:10px 16px;line-height:1.6;font-size:14px;border-bottom:1px solid #ebeef5}.log-item[data-v-210c3db8]:last-child{border-bottom:none}.log-item[data-v-210c3db8]:hover{background-color:#f0f2f5}.log-item .log-time[data-v-210c3db8]{color:#909399;white-space:nowrap}.log-item .log-operator[data-v-210c3db8]{color:#606266;font-weight:500;white-space:nowrap}.log-item .log-action[data-v-210c3db8]{color:#303133;word-break:break-word;max-width:400px}.button-group[data-v-210c3db8]{margin-top:24px;padding-top:20px;border-top:1px solid #ebeef5}.button-group .el-button[data-v-210c3db8]{margin-right:12px}.button-group .el-button[data-v-210c3db8]:last-child{margin-right:0}.readonly-field span[data-v-210c3db8]{color:#606266;font-size:14px}.helper-text[data-v-210c3db8]{margin-top:4px;font-size:12px;color:#909399;line-height:1.4}.tag-inline[data-v-210c3db8]{margin-right:8px}.tag-container[data-v-210c3db8]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px}.tag-item[data-v-210c3db8]{margin:0;border-radius:16px}.no-tags-text[data-v-210c3db8]{color:#909399;font-size:14px}.video-preview[data-v-210c3db8]{position:relative;cursor:pointer!important;background-color:#000}", "", {"version":3,"sources":["/workspace/src/views/user-workinfo/pages/UserWorkInfoDetail.vue"],"names":[],"mappings":"AACA,0CAA0C,WAAW,cAAc,CAClE,AACD,mCAAmC,YAAY,cAAc,CAC5D,AACD,4PAA4P,qBAAsB,cAAc,CAC/R,AACD,oCAAqC,oBAAqB,CACzD,AACD,+BAA+B,kBAAkB,CAChD,AACD,0CAA0C,eAAe,CACxD,AACD,oCAAoC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,SAAS,mBAAmB,cAAc,CACpM,AACD,kDAAkD,cAAc,eAAe,oBAAoB,aAAa,CAC/G,AACD,+CAA+C,cAAc,eAAe,kBAAkB,CAC7F,AACD,0CAA0C,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,QAAQ,CAC/M,AACD,uCAA8H,SAAS,eAAe,CACrJ,AACD,6BAA6B,kBAAkB,oBAAoB,CAClE,AACD,gCAAgC,kBAAkB,QAAQ,SAAS,UAAU,WAAW,yBAAyB,kBAAkB,sBAAsB,2CAA4C,mCAAoC,UAAU,mBAAmB,CACrQ,AACD,iCAAiC,YAAY,aAAa,yBAAyB,kBAAkB,eAAe,oCAAqC,2BAA4B,CACpL,AACD,uCAAuC,oBAAoB,CAC1D,AACD,oCAAoC,kBAAkB,SAAS,WAAW,eAAe,eAAe,cAAc,gBAAgB,kBAAkB,WAAW,YAAY,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,6CAA8C,qCAAsC,yCAA0C,iCAAkC,yBAA0B,8CAAiD,CACplB,AACD,0CAA0C,6BAA6B,oBAAoB,CAC1F,AACD,uCAAuC,oBAAoB,oBAAoB,aAAa,mBAAmB,eAAe,QAAQ,CACrI,AACD,mCAAmC,WAAW,YAAY,oBAAoB,iBAAiB,yBAAyB,kBAAkB,uBAAuB,eAAe,0DAA6D,kDAAqD,0CAA6C,+DAAoE,CAClZ,AACD,yCAAyC,qBAAqB,8BAA8B,qBAAqB,CAChH,AACD,gDAAgD,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,yBAAyB,eAAe,eAAe,cAAc,kBAAkB,YAAY,8BAA8B,qBAAqB,CACze,AACD,kDAAkD,eAAe,kBAAkB,aAAa,CAC/F,AACD,qDAAqD,gBAAgB,gBAAgB,uBAAuB,mBAAmB,UAAU,CACxI,AACD,oDAAoD,eAAe,yBAAyB,6BAA8B,CACzH,AACD,4EAA4E,8BAA+B,uBAAwB,mBAAoB,CACtJ,AACD,gCAAgC,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,MAAM,UAAU,yBAAyB,kBAAkB,iBAAiB,gBAAgB,yBAAyB,eAAe,CACjU,AACD,6BAA6B,aAAa,wCAAwC,SAAS,kBAAkB,yBAAyB,gCAAgC,gBAAgB,eAAe,cAAc,wBAAwB,gBAAgB,MAAM,SAAS,CACzQ,AACD,gJAAgJ,aAAa,CAC5J,AACD,2BAA2B,aAAa,wCAAwC,SAAS,kBAAkB,gBAAgB,eAAe,+BAA+B,CACxK,AACD,sCAAsC,kBAAkB,CACvD,AACD,iCAAiC,wBAAwB,CACxD,AACD,qCAAqC,cAAc,kBAAkB,CACpE,AACD,yCAAyC,cAAc,gBAAgB,kBAAkB,CACxF,AACD,uCAAuC,cAAc,sBAAsB,eAAe,CACzF,AACD,+BAA+B,gBAAgB,iBAAiB,4BAA4B,CAC3F,AACD,0CAA0C,iBAAiB,CAC1D,AACD,qDAAqD,cAAc,CAClE,AACD,sCAAsC,cAAc,cAAc,CACjE,AACD,8BAA8B,eAAe,eAAe,cAAc,eAAe,CACxF,AACD,6BAA6B,gBAAgB,CAC5C,AACD,gCAAgC,oBAAoB,oBAAoB,aAAa,mBAAmB,eAAe,OAAO,CAC7H,AACD,2BAA2B,SAAS,kBAAkB,CACrD,AACD,+BAA+B,cAAc,cAAc,CAC1D,AACD,gCAAgC,kBAAkB,yBAA0B,qBAAqB,CAChG","file":"UserWorkInfoDetail.vue","sourcesContent":["\n.re-el-form__flex .large[data-v-210c3db8]{width:100%;max-width:none\n}\n.form-input-width[data-v-210c3db8]{width:400px;max-width:100%\n}\n.form-input-width .el-select[data-v-210c3db8],.form-input-width .el-input[data-v-210c3db8],.form-input-width .el-input__inner[data-v-210c3db8],.form-input-width .el-select__tags[data-v-210c3db8],.form-input-width .el-select__tags-text[data-v-210c3db8]{width:100% !important;max-width:100%\n}\n.form-input-width>*[data-v-210c3db8]{width:100% !important\n}\n.el-form-item[data-v-210c3db8]{margin-bottom:22px\n}\n.el-form-item[data-v-210c3db8]:last-child{margin-bottom:0\n}\n.user-info-wrapper[data-v-210c3db8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;-ms-flex-wrap:wrap;flex-wrap:wrap\n}\n.user-info-wrapper .info-divider[data-v-210c3db8]{color:#dcdfe6;font-size:14px;-ms-flex-negative:0;flex-shrink:0\n}\n.user-info-wrapper .info-text[data-v-210c3db8]{color:#606266;font-size:14px;white-space:nowrap\n}\n.workcard-upload-wrapper[data-v-210c3db8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:16px\n}\n.photo-view-container[data-v-210c3db8]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:20px;margin-top:12px\n}\n.photo-item[data-v-210c3db8]{position:relative;display:inline-block\n}\n.photo-new-dot[data-v-210c3db8]{position:absolute;top:2px;left:2px;width:8px;height:8px;background-color:#f56c6c;border-radius:50%;border:1px solid #fff;-webkit-box-shadow:0 0 2px rgba(0,0,0,0.25);box-shadow:0 0 2px rgba(0,0,0,0.25);z-index:2;pointer-events:none\n}\n.workcard-image[data-v-210c3db8]{width:100px;height:100px;border:1px solid #dcdfe6;border-radius:4px;cursor:pointer;-webkit-transition:border-color 0.3s;transition:border-color 0.3s\n}\n.workcard-image[data-v-210c3db8]:hover{border-color:#409eff\n}\n.photo-delete-icon[data-v-210c3db8]{position:absolute;top:-8px;right:-8px;font-size:20px;cursor:pointer;color:#f56c6c;background:#fff;border-radius:50%;width:20px;height:20px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-shadow:0 2px 4px rgba(0,0,0,0.12);box-shadow:0 2px 4px rgba(0,0,0,0.12);-webkit-transition:-webkit-transform 0.2s;transition:-webkit-transform 0.2s;transition:transform 0.2s;transition:transform 0.2s, -webkit-transform 0.2s\n}\n.photo-delete-icon[data-v-210c3db8]:hover{-webkit-transform:scale(1.1);transform:scale(1.1)\n}\n.photo-view-container[data-v-210c3db8]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:12px\n}\n.photo-view-image[data-v-210c3db8]{width:80px;height:80px;-o-object-fit:cover;object-fit:cover;border:1px solid #dcdfe6;border-radius:4px;cursor:-webkit-zoom-in;cursor:zoom-in;-webkit-transition:border-color 0.3s, -webkit-transform 0.2s;transition:border-color 0.3s, -webkit-transform 0.2s;transition:border-color 0.3s, transform 0.2s;transition:border-color 0.3s, transform 0.2s, -webkit-transform 0.2s\n}\n.photo-view-image[data-v-210c3db8]:hover{border-color:#409eff;-webkit-transform:scale(1.05);transform:scale(1.05)\n}\n.photo-view-image.unknown-file[data-v-210c3db8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background-color:#f5f7fa;cursor:default;font-size:12px;color:#909399;text-align:center;padding:4px;-webkit-box-sizing:border-box;box-sizing:border-box\n}\n.photo-view-image.unknown-file i[data-v-210c3db8]{font-size:24px;margin-bottom:2px;color:#dcdfe6\n}\n.photo-view-image.unknown-file span[data-v-210c3db8]{line-height:1.2;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%\n}\n.photo-item video.photo-view-image[data-v-210c3db8]{cursor:pointer;background-color:#1a1a1a;pointer-events:auto !important\n}\n.photo-item video.photo-view-image[data-v-210c3db8]::-webkit-media-controls{display:-webkit-box !important;display:flex !important;opacity:1 !important\n}\n.log-container[data-v-210c3db8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:0;padding:0;background-color:#f5f7fa;border-radius:4px;max-height:300px;overflow-y:auto;border:1px solid #ebeef5;max-width:800px\n}\n.log-header[data-v-210c3db8]{display:grid;grid-template-columns:150px 150px 400px;gap:12px;padding:12px 16px;background-color:#fafafa;border-bottom:1px solid #ebeef5;font-weight:600;font-size:14px;color:#303133;position:-webkit-sticky;position:sticky;top:0;z-index:1\n}\n.log-header .log-time-header[data-v-210c3db8],.log-header .log-operator-header[data-v-210c3db8],.log-header .log-action-header[data-v-210c3db8]{color:#303133\n}\n.log-item[data-v-210c3db8]{display:grid;grid-template-columns:150px 150px 400px;gap:12px;padding:10px 16px;line-height:1.6;font-size:14px;border-bottom:1px solid #ebeef5\n}\n.log-item[data-v-210c3db8]:last-child{border-bottom:none\n}\n.log-item[data-v-210c3db8]:hover{background-color:#f0f2f5\n}\n.log-item .log-time[data-v-210c3db8]{color:#909399;white-space:nowrap\n}\n.log-item .log-operator[data-v-210c3db8]{color:#606266;font-weight:500;white-space:nowrap\n}\n.log-item .log-action[data-v-210c3db8]{color:#303133;word-break:break-word;max-width:400px\n}\n.button-group[data-v-210c3db8]{margin-top:24px;padding-top:20px;border-top:1px solid #ebeef5\n}\n.button-group .el-button[data-v-210c3db8]{margin-right:12px\n}\n.button-group .el-button[data-v-210c3db8]:last-child{margin-right:0\n}\n.readonly-field span[data-v-210c3db8]{color:#606266;font-size:14px\n}\n.helper-text[data-v-210c3db8]{margin-top:4px;font-size:12px;color:#909399;line-height:1.4\n}\n.tag-inline[data-v-210c3db8]{margin-right:8px\n}\n.tag-container[data-v-210c3db8]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px\n}\n.tag-item[data-v-210c3db8]{margin:0;border-radius:16px\n}\n.no-tags-text[data-v-210c3db8]{color:#909399;font-size:14px\n}\n.video-preview[data-v-210c3db8]{position:relative;cursor:pointer !important;background-color:#000\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5769:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5770);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("7c27abde", content, true, {});

/***/ }),

/***/ 5770:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"UserWorkInfoDetail.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5771:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkInfoHistory_vue__ = __webpack_require__(3081);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64badb84_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkInfoHistory_vue__ = __webpack_require__(5774);
function injectStyle (ssrContext) {
  __webpack_require__(5772)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64badb84"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkInfoHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64badb84_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkInfoHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 5772:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5773);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("011c03b3", content, true, {});

/***/ }),

/***/ 5773:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".user-info-list .image-list[data-v-64badb84]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:5px}.user-info-list .pagination-wrapper[data-v-64badb84]{margin-top:20px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.workcard-photo-cell .cell[data-v-64badb84]{overflow:visible}.photo-list[data-v-64badb84]{width:100%;height:100px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:20px;overflow-x:auto;overflow-y:hidden}.video-preview[data-v-64badb84]{position:relative;cursor:pointer!important;background-color:#000}", "", {"version":3,"sources":["/workspace/src/views/user-workinfo/components/work-info-history/WorkInfoHistory.vue"],"names":[],"mappings":"AACA,6CAA6C,oBAAoB,oBAAoB,aAAa,mBAAmB,eAAe,OAAO,CAC1I,AACD,qDAAqD,gBAAgB,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,sBAAsB,CAC5L,AACD,4CAA4C,gBAAgB,CAC3D,AACD,6BAA6B,WAAW,aAAa,oBAAoB,oBAAoB,aAAa,8BAA8B,6BAA6B,uBAAuB,mBAAmB,yBAAyB,sBAAsB,mBAAmB,SAAS,gBAAgB,iBAAiB,CAC1T,AACD,gCAAgC,kBAAkB,yBAA0B,qBAAqB,CAChG","file":"WorkInfoHistory.vue","sourcesContent":["\n.user-info-list .image-list[data-v-64badb84]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:5px\n}\n.user-info-list .pagination-wrapper[data-v-64badb84]{margin-top:20px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n.workcard-photo-cell .cell[data-v-64badb84]{overflow:visible\n}\n.photo-list[data-v-64badb84]{width:100%;height:100px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:20px;overflow-x:auto;overflow-y:hidden\n}\n.video-preview[data-v-64badb84]{position:relative;cursor:pointer !important;background-color:#000\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5774:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"user-info-list"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.dataList,"stripe":"","highlight-current-row":"","border":""}},[_vm._l((_vm.columns),function(attr){return [(attr.prop === 'sj_user_workinfo_audit_id')?_c('el-table-column',_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-link',{attrs:{"type":"text","href":("/user-workinfo/detail/" + (scope.row.sj_user_workinfo_audit_id)),"target":"_blank"}},[_vm._v("\n              "+_vm._s(scope.row.sj_user_workinfo_audit_id)+"\n            ")])]}}],null,true)},'el-table-column',attr,false)):(attr.prop === 'business_type_json')?_c('el-table-column',_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.getBusinessType(scope.row)))])]}}],null,true)},'el-table-column',attr,false)):_c('el-table-column',_vm._b({},'el-table-column',attr,false))]}),_vm._v(" "),_c('el-table-column',{key:"workcard_photo",attrs:{"prop":"workcard_photo","label":"工作证明","width":"500","class-name":"workcard-photo-cell"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"photo-list",attrs:{"id":("photoContainer" + (scope.$index))}},[_vm._l((scope.row.content.workcard_photo),function(url,index){return [(_vm.isVideoFile(url))?_c('video',{key:'video-' + index,staticClass:"avatar video-preview",staticStyle:{"width":"80px","height":"80px","flex-shrink":"0","cursor":"pointer"},attrs:{"src":url,"preload":"metadata"},on:{"click":function($event){return _vm.openVideoDialog(url, index, scope.row)}}}):(_vm.isImageFile(url))?_c('img',{key:'img-' + index,staticClass:"avatar",staticStyle:{"width":"80px","height":"80px","cursor":"zoom-in"},attrs:{"src":_vm._f("ossFormatJpg")(url),"alt":""},on:{"click":function($event){return _vm.onViewPhotos(index,scope.$index)}}}):_c('div',{key:'unknown-' + index,staticClass:"avatar unknown-file",staticStyle:{"width":"80px","height":"80px","display":"flex","flex-direction":"column","align-items":"center","justify-content":"center","background-color":"#f5f7fa","font-size":"12px","color":"#909399"},attrs:{"title":url}},[_c('i',{staticClass:"el-icon-document",staticStyle:{"font-size":"24px","margin-bottom":"2px","color":"#dcdfe6"}}),_vm._v(" "),_c('span',{staticStyle:{"line-height":"1.2","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap","width":"100%"}},[_vm._v("未知类型的文件")])])]})],2)]}}])})],2),_vm._v(" "),_c('div',{staticClass:"pagination-wrapper"},[_c('el-pagination',{attrs:{"current-page":_vm.pagination.current,"page-sizes":[10, 20, 50, 100],"page-size":_vm.pagination.size,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)],1),_vm._v(" "),_c('video-player-dialog',{attrs:{"visible":_vm.videoDialogVisible,"videos":_vm.videoDialogVideos,"index":_vm.videoDialogIndex},on:{"update:visible":function($event){_vm.videoDialogVisible=$event}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 5775:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/user-workinfo/table"}},[_vm._v("用户职业信息审核列表")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"职业信息提交详情","name":"职业信息提交详情"}},[_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("表单")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.detail,"size":"medium","label-width":"140px"}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"large"},[_c('el-form-item',{attrs:{"label":"ID","prop":"id"}},[_c('span',[_vm._v(_vm._s(_vm.detail.id))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"状态","prop":"status_cn"}},[_c('span',{style:({color: _vm.setStatusCNColor()})},[_vm._v(_vm._s(_vm.detail.status_cn))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"用户信息","prop":"userid"}},[_c('div',{staticClass:"user-info-wrapper"},[_c('el-link',{attrs:{"target":"_blank","href":("/users/detail/info?userid=" + (_vm.detail.userid)),"type":"primary"}},[_vm._v("\n                    ID: "+_vm._s(_vm.detail.userid)+"\n                  ")]),_vm._v(" "),_c('span',{staticClass:"info-divider"},[_vm._v("|")]),_vm._v(" "),_c('span',{staticClass:"info-text"},[_vm._v("姓名: "+_vm._s(_vm.detail.realname))])],1)]),_vm._v(" "),(_vm.allowAudit())?_c('el-form-item',{attrs:{"label":"行业","prop":"business_type"}},[_c('el-select',{staticClass:"form-input-width",attrs:{"clearable":"","placeholder":"请选择"},on:{"change":_vm.onBusinessTypeChange},model:{value:(_vm.editForm.business_type),callback:function ($$v) {_vm.$set(_vm.editForm, "business_type", $$v)},expression:"editForm.business_type"}},_vm._l((_vm.options.business_type),function(item){return _c('el-option',{key:item.id,attrs:{"disabled":item.disabled,"label":item.title,"value":item.id}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px"}},[_vm._v(_vm._s(item.subTitle))])])}),1),_vm._v(" "),_c('div',{staticClass:"helper-text"},[_vm._v("提示：审核通过后，将自动为用户追加该行业的对应标签")]),_vm._v(" "),(_vm.industryTags && _vm.industryTags.length)?_c('div',{staticClass:"helper-text"},[_vm._v("\n                  行业对应标签：\n                  "),_vm._l((_vm.industryTags),function(tag){return _c('span',{key:tag.id,staticClass:"tag-inline"},[_vm._v("\n                  "+_vm._s(tag.tagname)+" ("+_vm._s(tag.id)+")\n                ")])})],2):_vm._e()],1):_c('el-form-item',{staticClass:"readonly-field",attrs:{"label":"行业","prop":"business_type_json"}},[_c('span',[_vm._v(_vm._s(_vm.getBusinessType()))])]),_vm._v(" "),(_vm.allowAudit())?_c('el-form-item',{attrs:{"label":"工种","prop":"work_type"}},[_c('el-select',{staticClass:"form-input-width",attrs:{"placeholder":"请先选择行业"},model:{value:(_vm.editForm.work_type),callback:function ($$v) {_vm.$set(_vm.editForm, "work_type", $$v)},expression:"editForm.work_type"}},_vm._l((_vm.filtered_work_type),function(item){return _c('el-option',{key:item.id,attrs:{"disabled":item.disabled,"label":item.title,"value":item.id}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px"}},[_vm._v(_vm._s(item.desc))])])}),1)],1):_c('el-form-item',{staticClass:"readonly-field",attrs:{"label":"工种","prop":"work_type_cn"}},[_c('span',[_vm._v(_vm._s(_vm.detail.work_type_cn))])]),_vm._v(" "),(_vm.needMainBrand())?_c('el-form-item',{attrs:{"label":"主营品牌","prop":"main_brand"}},[(_vm.allowAudit())?_c('el-input',{staticClass:"form-input-width",attrs:{"placeholder":"请输入主营品牌"},model:{value:(_vm.editForm.main_brand),callback:function ($$v) {_vm.$set(_vm.editForm, "main_brand", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"editForm.main_brand"}}):_c('span',[_vm._v(_vm._s(_vm.getMainBrand()))])],1):_vm._e(),_vm._v(" "),_c('el-form-item',{staticClass:"readonly-field",attrs:{"label":"零工所在地","prop":"user_location"}},[_c('span',[_vm._v(_vm._s(_vm.getUserLocation()))])]),_vm._v(" "),(_vm.allowAudit())?_c('el-form-item',{attrs:{"label":"公司名称","prop":"belongto"}},[_c('el-autocomplete',{staticClass:"form-input-width",attrs:{"fetch-suggestions":_vm.queryCompanyList,"placeholder":"请输入或选择公司名称","clearable":"","trigger-on-focus":false},on:{"select":_vm.handleCompanySelect},model:{value:(_vm.editForm.belongto),callback:function ($$v) {_vm.$set(_vm.editForm, "belongto", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"editForm.belongto"}})],1):_c('el-form-item',{staticClass:"readonly-field",attrs:{"label":"公司名称","prop":"belongto"}},[_c('span',[_vm._v(_vm._s(_vm.detail.belongto))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"工作证明","prop":"workcard_photo"}},[_c('div',{staticClass:"workcard-upload-wrapper"},[(_vm.allowAudit())?_c('el-upload',{attrs:{"action":"","auto-upload":false,"show-file-list":false,"accept":".jpg,.jpeg,.png,.mp4","on-change":function (query) { return _vm.onChangeFile(query); }}},[_c('el-button',{attrs:{"type":"primary","size":"small"}},[_vm._v("上传工作证明\n                    ")])],1):_vm._e(),_vm._v(" "),(_vm.editForm.workcard_photo && _vm.editForm.workcard_photo.length > 0)?_c('div',{staticClass:"photo-view-container",attrs:{"id":"photoContainer"}},_vm._l((_vm.editForm.workcard_photo),function(photo,index){return _c('div',{key:'workcard-' + index,staticClass:"photo-item"},[(_vm.isNewWorkcardPhoto(photo))?_c('span',{staticClass:"photo-new-dot",attrs:{"title":"零工新补证据"}}):_vm._e(),_vm._v(" "),(_vm.isVideoFile(photo))?_c('video',{staticClass:"photo-view-image video-preview",attrs:{"src":photo,"preload":"metadata"},on:{"click":function($event){return _vm.openVideoDialog(photo, index)}}}):(_vm.isImageFile(photo))?_c('img',{staticClass:"photo-view-image",attrs:{"src":_vm._f("ossFormatJpg")(photo),"alt":""},on:{"click":function($event){return _vm.onViewPhotos(index)}}}):_c('div',{staticClass:"photo-view-image unknown-file",attrs:{"title":photo}},[_c('i',{staticClass:"el-icon-document"}),_vm._v(" "),_c('span',[_vm._v("未知文件")])]),_vm._v(" "),(_vm.allowAudit())?_c('i',{staticClass:"el-icon-error photo-delete-icon",on:{"click":function($event){return _vm.onDeletePhoto(index)}}}):_vm._e()])}),0):_vm._e()],1)]),_vm._v(" "),(_vm.allowAudit())?_c('el-form-item',{attrs:{"label":"当前标签"}},[(_vm.existingTags && _vm.existingTags.length)?_c('div',{staticClass:"tag-container"},_vm._l((_vm.existingTags),function(item){return _c('el-tag',{key:item.id,staticClass:"tag-item",attrs:{"type":"success"}},[_vm._v("\n                    "+_vm._s(item.tagname)+" ("+_vm._s(item.id)+")\n                  ")])}),1):_c('span',{staticClass:"no-tags-text"},[_vm._v("暂无标签")])]):_vm._e(),_vm._v(" "),(_vm.allowAudit())?_c('el-form-item',{attrs:{"label":"新增标签","prop":"tag_add"}},[_c('div',{staticClass:"form-input-width"},[_c('remote-select',{attrs:{"disabled":!_vm.allowAudit(),"placeholder":"请输入标签名称搜索添加标签","queryRequest":function (_) { return _vm.getUserTagTable(Object.assign.apply(Object, [ {'is_group': 0} ].concat( _ ))); },"findRequest":_vm.getUserTagDetail,"clearable":"","multiple":"","keyword-key":"keyword","value-key":"id","label-key":"tagname","id-key":"id"},model:{value:(_vm.editForm.tag_add),callback:function ($$v) {_vm.$set(_vm.editForm, "tag_add", $$v)},expression:"editForm.tag_add"}})],1)]):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"日志","prop":"log"}},[_c('div',{staticClass:"log-container"},[_c('div',{staticClass:"log-header"},[_c('span',{staticClass:"log-time-header"},[_vm._v("时间")]),_vm._v(" "),_c('span',{staticClass:"log-operator-header"},[_vm._v("操作人")]),_vm._v(" "),_c('span',{staticClass:"log-action-header"},[_vm._v("操作内容")])]),_vm._v(" "),_vm._l((_vm.reversedLogs),function(item,index){return _c('div',{key:index,staticClass:"log-item"},[_c('span',{staticClass:"log-time"},[_vm._v(_vm._s(item.created_at))]),_vm._v(" "),_c('span',{staticClass:"log-operator"},[_vm._v(_vm._s(item.operator.name)+" ("+_vm._s(item.operator.id)+")")]),_vm._v(" "),_c('span',{staticClass:"log-action"},[_vm._v(_vm._s(item.action))])])})],2)]),_vm._v(" "),(_vm.allowAudit())?_c('el-form-item',{attrs:{"label":"不通过原因","prop":"failed_reason"}},[_c('el-input',{staticClass:"form-input-width",attrs:{"placeholder":"审核不通过时请填写原因（必填）","maxlength":"200","show-word-limit":""},model:{value:(_vm.auditForm.failed_reason),callback:function ($$v) {_vm.$set(_vm.auditForm, "failed_reason", $$v)},expression:"auditForm.failed_reason"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{staticClass:"button-group"},[(_vm.allowAudit())?[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-check"},on:{"click":function($event){return _vm.auditPass()}}},[_vm._v("审核通过\n                  ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger","icon":"el-icon-close"},on:{"click":function($event){return _vm.auditReject()}}},[_vm._v("审核不通过\n                  ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"warning","icon":"el-icon-refresh-left"},on:{"click":function($event){return _vm.reloadData()}}},[_vm._v("数据还原\n                  ")]),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-back"},on:{"click":function($event){return _vm.goBackToTable()}}},[_vm._v("返回列表页\n                  ")])]:[_c('el-button',{attrs:{"icon":"el-icon-back"},on:{"click":function($event){return _vm.goBackToTable()}}},[_vm._v("返回列表页\n                  ")])]],2)],1)])])],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"职业信息修改记录","name":"职业信息修改记录"}},[(_vm.detail.userid)?_c('work-info-history',{attrs:{"userId":Number(_vm.detail.userid)}}):_vm._e()],1)],1),_vm._v(" "),_c('video-player-dialog',{attrs:{"visible":_vm.videoDialogVisible,"videos":_vm.videoDialogVideos,"index":_vm.videoDialogIndex},on:{"update:visible":function($event){_vm.videoDialogVisible=$event}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/user-work-info-form.3407fdcf1b82e27ab79a.js